import * as React from 'react';
import { useContext } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import { Button } from '@mui/material';
import { GlobalContext } from '../../Context/GlobalContext/GlobalContextProvider';
import { LoggingContext } from '../../Context/LoggingContext/LoggingContext';

function MiddleButtons() {
  const location = useLocation();
  const { pathname } = useLocation();
  const { filterMobileOpen, setFilterMobileOpen } = React.useContext(GlobalContext);
  const { addLog } = useContext(LoggingContext);
  const [showFilterButton, setShowFilterButton] = React.useState(pathname === '/');
  const navigate = useNavigate();

  React.useEffect(() => {
    setShowFilterButton(pathname === '/');
  }, [pathname]);

  return (
    <Box sx={{ flexGrow: 1, display: 'flex' }}>
      <Button
        sx={{
          color: 'white',
          fontSize: {
            xs: '10px',
            sm: '14px',
          },
        }}
        onClick={() => {
          navigate(`/`);
          window.scrollTo(0, 0);
          addLog('Clicked NavBar Logo', location.pathname);
        }}
        endIcon={<SearchIcon />}
      >
        BETTERFIT
      </Button>
      {showFilterButton && (
        <Button
          sx={{
            color: 'white',
            fontSize: {
              xs: '10px',
              sm: '14px',
            },
            display: {
              xs: 'block',
              md: 'none',
            },
          }}
          size='small'
          color='primary'
          variant='contained'
          onClick={() => {
            addLog('Clicked NavBar Open Filter Button', location.pathname);
            setFilterMobileOpen((prev) => !prev);
          }}
        >
          {filterMobileOpen ? 'Close' : 'Open'} Filter
        </Button>
      )}
    </Box>
  );
}

export default function NavBar() {
  const location = useLocation();
  const { addLog } = useContext(LoggingContext);
  const [anchorEl, setAnchorEl] = React.useState<Element | null>(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState<Element | null>(null);
  const navigate = useNavigate();

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleRightProfileMenuOpen = (event: { currentTarget: Element }) => {
    setAnchorEl(event.currentTarget);
    addLog('Clicked NavBar AccountCircle Menu Button', location.pathname);
  };

  const handleLeftMenuOpen = (event: { currentTarget: Element }) => {
    setMobileMoreAnchorEl(event.currentTarget);
    addLog('Clicked NavBar Menu Button', location.pathname);
  };

  const handleLeftMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleRightMenuClose = () => {
    setAnchorEl(null);
    // handleLeftMobileMenuClose();
  };

  // Right Menu
  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleRightMenuClose}
      sx={{ zIndex: 1320 }}
    >
      <MenuItem
        onClick={() => {
          addLog('/settings clicked from navbar', location.pathname);
          navigate('/settings');
          setAnchorEl(null);
        }}
      >
        My Settings
      </MenuItem>
      <MenuItem
        onClick={() => {
          addLog('/idealmeasurements clicked from navbar', location.pathname);
          navigate('/idealmeasurements');
          setAnchorEl(null);
        }}
      >
        My Ideal Measurements
      </MenuItem>
    </Menu>
  );

  const leftMenuId = 'primary-search-account-menu-mobile';
  const renderLeftMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={leftMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleLeftMobileMenuClose}
    >
      <MenuItem onClick={handleLeftMobileMenuClose}>
        <Link style={{ color: 'inherit', cursor: 'inherit', textDecoration: 'inherit' }} to='/'>
          Coming Soon
        </Link>
      </MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position='fixed' sx={{ zIndex: 1250 }} color='secondary'>
        <Toolbar>
          {/* Left Icon Button */}
          <IconButton
            size='large'
            edge='start'
            color='inherit'
            aria-label='open drawer'
            sx={{ mr: 2 }}
            onClick={handleLeftMenuOpen}
          >
            <MenuIcon />
          </IconButton>
          {/* Middle Buttons */}
          <MiddleButtons />
          {/* Right Icon Button */}
          <Box sx={{ display: { xs: 'flex', md: 'flex' } }}>
            <IconButton
              size='large'
              edge='end'
              aria-label='account of current user'
              aria-controls={menuId}
              aria-haspopup='true'
              onClick={handleRightProfileMenuOpen}
              color='inherit'
            >
              <AccountCircle />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderLeftMobileMenu}
      {renderMenu}
    </Box>
  );
}
